import { gql } from '@apollo/client';
import { ORGANIZATION } from './Organization';
import { TAX_DETAIL } from './TaxDetail';

export const USER_INFO = gql`
  fragment UserInfo on User {
    id
    accountYears
    airtableId
    blocked
    createdAt
    customerId
    deletedAt
    email
    emailVerified
    firstName
    includeFees
    secretMode
    isTest
    businessUser
    lastName
    lastSuccessfulCharge
    lockedTilDate
    lockedThroughYear
    loginCount
    marginTradeAccount
    minimizationForAllYears
    orgDemoUser
    organizationId
    phone
    plan
    recalcByAccount
    recalcByAccountStartYear
    reconMode
    hideSpam
    resetPasswordExpires
    role
    orgRoles {
      userId
      roleId
      organizationId
      createdAt
      updatedAt
      organization {
        ...Organization
      }
      role {
        name
      }
    }
    subscriptionId
    taxDetails {
      ...TaxDetail
    }
    twoFactorEnabled
    updatedAt
    useHoursMinsComparison
    lastMadeEditsAt
    usesGroupsSince
    dataModelV2UpgradeState
    v2TransitionProgress
  }
  ${TAX_DETAIL}
  ${ORGANIZATION}
`;
